const trimTrailingSlashes = (url) => url.replace(/\/+$/, '');

export const marketingBaseUrl = trimTrailingSlashes(
  process.env.REACT_APP_MARKETING_URL
    || (process.env.NODE_ENV === 'production' ? 'https://www.softwareiq.io' : 'http://localhost:3001')
);

export const researchBaseUrl = trimTrailingSlashes(
  process.env.REACT_APP_RESEARCH_URL
    || (process.env.NODE_ENV === 'production' ? 'https://research.softwareiq.io' : 'http://localhost:3000')
);

export const marketingPricingUrl = `${marketingBaseUrl}/pricing`;
export const operatingKpisDocumentationPath = '/documentation/api/operating-kpis';
export const marketingOperatingKpisDocumentationUrl = `${marketingBaseUrl}/documentation/api/operating-kpis`;
export const marketingCoverageUrl = `${marketingBaseUrl}/coverage`;
export const marketingContactUrl = `${marketingBaseUrl}/contact`;
export const marketingDocumentationUrl = `${marketingBaseUrl}/documentation`;
export const marketingPrivacyUrl = `${marketingBaseUrl}/privacy`;
export const marketingTermsUrl = `${marketingBaseUrl}/termsandconditions`;

export const openMarketingPricing = () => {
  window.location.assign(marketingPricingUrl);
};
